import { useWatch } from "antd/es/form/Form";
import { FormValues } from "../types/FormValues";

export function useTypedWatch<Key extends keyof FormValues>(key: Key) {
  return useWatch<FormValues[Key]>(key);
}
